import React from 'react';
import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';
import { colors } from '../../styles/constants';
import { StyledRouteLink } from '../../components/StyledLink';

const TransactionId = (
    {
        transactionId,
        fallback,
    }: {
        transactionId?: string;
        fallback?: any;
    }
) => {
    if (!transactionId) {
        return fallback || null;
    }
    const regex = /^[PT]\d{8}\.[a-zA-Z0-9]{22}$/;
    if (transactionId && regex.test(transactionId)) {
        const aid = transactionId.split('.')[0];
        return <StyledRouteLink to={`/${aid}/payments/transactions/${transactionId}`}>{transactionId}</StyledRouteLink>;
    }
    return <>{transactionId}</>;
};

export default TransactionId;
